import { json, useNavigate } from "react-router-dom";
import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import moment from "moment-timezone";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@mui/material";
import LoadingScreen from "../../component/LoadingScreen";

const CreateSalesOrder = () => {
  const navigate = useNavigate();
  const [orderDetail, setOrderDetail] = useState({
    orderItemlistByOrderId: [],
    orderFeedbackListByOrderId: [],
    orderApprovalListByOrderId: [],
  });

  let [token, setToken] = useState("");
  const resource = "create-sales-order";
  const [salesOrderDestination, setSalesOrderDestination] = useState("");
  const [internalName, setInternalName] = useState("");
  const [internalEmail, setInternalEmail] = useState("");
  const [salesOrderDate, setSalesOrderDate] = useState("");
  const [salesOrderNo, setSalesOrderNo] = useState("");
  const [totalMRC, setTotalMRC] = useState(0);
  const [totalNRC, setTotalNRC] = useState(0);
  const [totalVat, setTotalVat] = useState(0);
  const [error, setError] = useState(null);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [openFail, setOpenFail] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState("");
  const [locale, setLocale] = useState("id-ID");
  const [salesOrderPriceUSD, setSalesOrderPriceUSD] = useState("");
  const [salesOrderPriceIDR, setSalesOrderPriceIDR] = useState("");
  const [msaDate, setMsaDate] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [specifiedTc, setSpecifiedTc] = useState("");
  const [isDownloadActive, setIsDownloadActive] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [downloadUrl, setDownloadUrl] = useState("");
  const [fileName, setFileName] = useState("");
  const [openFailConfirm, setOpenFailConfirm] = useState(false);
  const [openConfirmSucces, setOpenConfirmSucces] = useState(false);
  const [vat, setVat] = useState();

  useEffect(() => {
    const fetchVat = async () => {
      try {
        const key = "XCP_VAT";
        const result = await axios.get(
          `https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/master/configuration/find-by-key?key=${key}`
        );

        const responseVat = result.data.find(
          (item) => item.xcp_key === "XCP_VAT"
        )?.xcp_value;

        setVat(responseVat);
      } catch (error) {
        console.error("Error fetching vat:", error);
      }
    };

    fetchVat();
  }, []);

  const handleMonth = (index, newMonthValue) => {
    // Create a new copy of the order items array
    const updatedOrderItems = [...orderDetail.orderItemlistByOrderId];

    // Update the month value for the specific order
    updatedOrderItems[index].month = newMonthValue;
    updatedOrderItems[index].totalMRC =
      newMonthValue * updatedOrderItems[index].subtotalMRC;
    updatedOrderItems[index].totalNRC = updatedOrderItems[index].sales_order_nrc_sub_total;

    // Update the state with the modified order list
    setOrderDetail({
      ...orderDetail,
      orderItemlistByOrderId: updatedOrderItems,
    });

    let totalMRC = 0;
    let totalNRC = 0;
    let totalVat = 0;
    orderDetail.orderItemlistByOrderId.forEach((item) => {
      totalMRC += item.month * item.subtotal_mrc;
      totalNRC += item.sales_order_nrc_sub_total;
      totalVat += (item.month * item.vat_mrc) + item.sales_order_nrc_tax;
    });
    setTotalMRC(totalMRC);
    setTotalNRC(totalNRC);
    setTotalVat(totalVat);
  };

  const handleUnit = (index, value) => {
    // Create a new copy of the order items array
    const updatedOrderItems = [...orderDetail.orderItemlistByOrderId];

    // Update the month value for the specific order
    updatedOrderItems[index].unit = value;

    // Update the state with the modified order list
    setOrderDetail({
      ...orderDetail,
      orderItemlistByOrderId: updatedOrderItems,
    });
  };

  const handleUnitPriceNRC = (index, value) => {
    // Create a new copy of the order items array
    const updatedOrderItems = [...orderDetail.orderItemlistByOrderId];

    // Update the month value for the specific order
    updatedOrderItems[index].sales_order_nrc_unit_price = value;
    updatedOrderItems[index].sales_order_nrc_sub_total =
      updatedOrderItems[index].cable_quantity * value;
    updatedOrderItems[index].sales_order_nrc_tax =
      updatedOrderItems[index].sales_order_nrc_sub_total * (vat / 100);

    // Update the state with the modified order list
    setOrderDetail({
      ...orderDetail,
      orderItemlistByOrderId: updatedOrderItems,
    });

    let totalMRC = 0;
    let totalNRC = 0;
    let totalVat = 0;
    orderDetail.orderItemlistByOrderId.forEach((item) => {
      totalMRC += item.month * item.subtotal_mrc;
      totalNRC += item.sales_order_nrc_sub_total;
      totalVat += (item.month * item.vat_mrc) + item.sales_order_nrc_tax;
    });
    setTotalMRC(totalMRC);
    setTotalNRC(totalNRC);
    setTotalVat(totalVat);
  };

  const handleUnitPriceMRC = (index, value) => {
    // Create a new copy of the order items array
    const updatedOrderItems = [...orderDetail.orderItemlistByOrderId];

    // Update the month value for the specific order
    updatedOrderItems[index].sales_order_mrc_unit_price = value;
    updatedOrderItems[index].subtotal_mrc =
      updatedOrderItems[index].cable_quantity * value;
    updatedOrderItems[index].vat_mrc =
      updatedOrderItems[index].subtotal_mrc * (vat / 100);

    // Update the state with the modified order list
    setOrderDetail({
      ...orderDetail,
      orderItemlistByOrderId: updatedOrderItems,
    });

    let totalMRC = 0;
    let totalNRC = 0;
    let totalVat = 0;
    orderDetail.orderItemlistByOrderId.forEach((item) => {
      totalMRC += item.month * item.subtotal_mrc;
      totalNRC += item.sales_order_nrc_sub_total;
      totalVat += (item.month * item.vat_mrc) + item.sales_order_nrc_tax;
    });
    setTotalMRC(totalMRC);
    setTotalNRC(totalNRC);
    setTotalVat(totalVat);
  };

  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    setToken(storedToken);

    const checkSessionToken = async () => {
      try {
        const response = await fetch(
          `https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/auth/check-session?token=${storedToken}&resource=${resource}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          setError(data.message || "Failed to fetch session token data");
          throw new Error(data.message || "Failed to fetch session token data");
        }

        // Parse response text as a boolean value
        const text = await response.text();
        const data = text === "true";

        if (data) {
        } else {
          window.alert("Session is invalid");
          navigate("/login");
        }
      } catch (error) {
        console.error("Fetch Error:", error.message);
        setError("Fetch Error: " + error.message);
      }
    };

    checkSessionToken();
  }, []);

  useEffect(() => {
    // Retrieve the token from local storage
    const storedToken = localStorage.getItem("token");
    setToken(storedToken);

    // Fetch internal data using the token
    const fetchInternalData = async () => {
      try {
        const response = await fetch(
          `https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/auth/find-by-token?token=${storedToken}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        const data = await response.json();

        if (!response.ok) {
          setError(data.message || "Failed to fetch internal data");
          throw new Error(data.message || "Failed to fetch internal data");
        }

        setInternalName(data[0].xcp_internal_name);
        setInternalEmail(data[0].xcp_internal_email);
      } catch (error) {
        console.error("Fetch Error:", error.message);
        setError("Fetch Error: " + error.message);
      }
    };

    fetchInternalData();
  }, []);

  useEffect(() => {
    // Set the current date for the order date field
    const currentDate = new Date().toISOString().split("T")[0];
    setSalesOrderDate(currentDate);
  }, []);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const orderId = searchParams.get("param1");

  useEffect(() => {
    // Fetch internal data using the token
    const fetchFindPrice = async () => {
      try {
        const response = await fetch(
          `https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/customer/find-price?orderId=${orderId}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        const data = await response.json();

        if (!response.ok) {
          setError(data.message || "Failed to fetch find price");
          throw new Error(data.message || "Failed to fetch find price");
        }

        setSalesOrderPriceIDR(data[0].sales_order_price_idr);
        setSalesOrderPriceUSD(data[0].sales_order_price_usd);
        loadOrderDetail(
          searchParams.get("param1"),
          data[0].sales_order_price_usd,
          data[0].sales_order_price_idr
        );
      } catch (error) {
        console.error("Fetch Error:", error.message);
        setError("Fetch Error: " + error.message);
      }
    };

    if (vat) {
      fetchFindPrice();
    }
  }, [vat]);

  const loadOrderDetail = async (
    xcpOrderId,
    salesOrderPriceUSD,
    salesOrderPriceIDR
  ) => {
    try {
      const result = await axios.get(
        `https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/order/order-detail?param1=${xcpOrderId}`
      );

      const data = result.data;

      let salesOrderPrice = null;
      if (data.sales_order_currency === "IDR") {
        salesOrderPrice = salesOrderPriceIDR;
      } else if (data.sales_order_currency === "USD") {
        salesOrderPrice = salesOrderPriceUSD;
      }

      let totalMRC = 0;
      let totalNRC = 0;
      let totalVat = 0;
      data.orderItemlistByOrderId.forEach((item) => {
        const cable_type_a = item.cable_type_a;
        const a_end_rack_id = item.a_end_rack_id;
        const company_requestor = data.company_requestor;
        const interface_name_a = item.interface_name_a;

        const cable_type_b = item.cable_type_b;
        const b_end_rack_id = item.b_end_rack_id;
        const company_destination = data.company_destination;
        const interface_name_b = item.interface_name_b;

        item.service_description =
          "Location: " +
          data.order_location_name +
          "\nCross Connect using " +
          cable_type_a +
          " :\nFrom: " +
          a_end_rack_id +
          " (" +
          company_requestor +
          ") Interface type " +
          interface_name_a +
          "\n\nCross Connect using " +
          cable_type_b +
          " :\nTo: " +
          b_end_rack_id +
          " (" +
          company_destination +
          ") Interface type " +
          interface_name_b;

        if (item.month === null) {
          item.month = 12;
        }
        if (item.unit === null) {
          item.unit = "pair";
        }
        if (item.sales_order_nrc_unit_price === null) {
          item.sales_order_nrc_unit_price = 0;
        }
        item.sales_order_nrc_sub_total =
          item.cable_quantity * item.sales_order_nrc_unit_price;
        item.sales_order_nrc_tax = item.sales_order_nrc_sub_total * (vat / 100);

        if (item.sales_order_mrc_unit_price === null) {
          item.sales_order_mrc_unit_price = salesOrderPrice;
        }
        item.subtotal_mrc =
          item.cable_quantity * item.sales_order_mrc_unit_price;
        item.vat_mrc = item.subtotal_mrc * (vat / 100);
        totalMRC += item.month * item.subtotal_mrc;
        totalNRC += item.sales_order_nrc_sub_total;
        totalVat += (item.month * item.vat_mrc) + item.sales_order_nrc_tax;
      });
      setTotalMRC(totalMRC);
      setTotalNRC(totalNRC);
      setTotalVat(totalVat);

      if (data.sales_order_tc_option !== null) {
        setSelectedOption(data.sales_order_tc_option);
      }
      if (data.sales_order_tc !== null) {
        setSpecifiedTc(data.sales_order_tc);
      }
      setOrderDetail(data);
      setSalesOrderNo(
        createSalesOrderNo(orderId, data.order_location_name, getCurrentYear())
      );

      if (data.sales_order_msa_date === null) {
        setMsaDate(data.default_sales_order_msa_date.split("T")[0]);
      } else if (data.sales_order_msa_date !== null) {
        setMsaDate(data.sales_order_msa_date.split("T")[0]);
      }

      fetchCompany(data.company_requestor_id);
    } catch (error) {
      console.error("Fetch Error Order Detail:", error);
      setError("Fetch Error Order Detail: " + error.message);
    }
  };

  const fetchCompany = async (companyId) => {
    try {
      const result = await axios.get(
        `https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/company/find-by-id?companyId=${companyId}`
      );

      const data = result.data;

      if (data && data[0].company_sales_pic) {
        fetchInternal(data[0].company_sales_pic);
      } else {
        console.error("company_sales_pic tidak ditemukan atau undefined");
      }
    } catch (error) {
      console.error("Fetch Error Company:", error);
      setError("Fetch Error Company: " + error.message);
    }
  };

  const fetchInternal = async (internalId) => {
    try {
      const result = await axios.get(
        `https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/master/internal/find-by-id?internalId=${internalId}`
      );

      const data = result.data;

      if (data && data[0].xcp_internal_name) {
        setSalesOrderDestination(data[0].xcp_internal_name);
      } else {
        console.error("xcp_internal_name tidak ditemukan atau undefined");
      }
    } catch (error) {
      console.error("Fetch Error Internal:", error);
      setError("Fetch Error Internal: " + error.message);
    }
  };

  function createSalesOrderNo(orderId, locationName, currentYear) {
    let salesOrderNo = `${orderId}/SO/XC/${locationName}/${currentYear}`;
    return removeSpaces(salesOrderNo);
  }

  const removeSpaces = (str) => str.replace(/\s+/g, "");

  const getCurrentYear = () => {
    const date = new Date();
    return date.getFullYear() % 100;
  };

  const handleConfirmation = async (event) => {
    event.preventDefault();
    const form = event.target.closest("form"); // Get form element
    const isValid = form.checkValidity();

    if (isValid) {
      // Form is valid, proceed with submission or further logic
      const buttonValue = event.target.querySelector(
        '[type="submit"]:focus'
      )?.value;
      if (buttonValue === "confirm") {
        handleConfirm();
      } else if (buttonValue === "submit") {
        setOpenConfirm(true);
      }
    } 
  };

  const handleConfirm = async (event) => {
    setIsLoading(true);

    const inputSalesOrder = {
      order_id: orderId,
      email_requestor: internalEmail,
      sales_order_destination: salesOrderDestination,
      sales_order_no: salesOrderNo,
      msa_date: getDateTimeInUserTimeZone(msaDate),
      sales_order_currency: selectedCurrency,
      sales_order_date: getDateTimeInUserTimeZone(salesOrderDate),
      sales_order_prepare_by: internalName,
      sales_order_tc_option: selectedOption,
      sales_order_tc: specifiedTc,
      orderItemlist: [],
      total_nrc: totalNRC,
      total_mrc: totalMRC,
      total_vat: totalVat,
      vat: vat,
    };

    orderDetail.orderItemlistByOrderId.forEach((item) => {
      inputSalesOrder.orderItemlist.push({
        item_id: item.item_id,
        service_description: item.service_description,
        month: item.month,
        quantity: item.cable_quantity,
        unit: item.unit,
        sales_order_nrc_unit_price: item.sales_order_nrc_unit_price,
        sales_order_nrc_sub_total: item.sales_order_nrc_sub_total,
        sales_order_nrc_tax: item.sales_order_nrc_tax,
        sales_order_mrc_unit_price: item.sales_order_mrc_unit_price,
        subtotal_mrc: item.subtotal_mrc,
        vat_mrc: item.vat_mrc,
      });
    });

    try {
      const response = await fetch(
        "https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/order/confirm-sales-order",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(inputSalesOrder),
        }
      );

      const data = await response.json();
      const responseBody = JSON.parse(data.body);

      if (!response.ok) {
        throw new Error("Failed to confirm Sales Order");
      }

      const { message } = responseBody;
      const { downloadUrl } = responseBody;
      const { fileName } = responseBody;
      if (message == "success") {
        setIsDownloadActive(true);
        setOpenConfirmSucces(true);
        setDownloadUrl(downloadUrl);
        setFileName(fileName);
      } else {
        setOpenFailConfirm(true);
      }
    } catch (error) {
      setError("Submission Error: " + error.message);
      console.error("Submission Error:", error.message);
      setOpenFailConfirm(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    setOpenConfirm(false);
    setOpenFail(false);
    setOpenConfirmSucces(false);
    setOpenFailConfirm(false);
  };

  function getDateTimeInUserTimeZone(date) {
    const userTimeZone = moment.tz.guess();
    // Get the current time in the user's local time zone
    const currentTime = moment.tz(userTimeZone).format("HH:mm:ss");

    // Combine the selected date with the current time
    const dateTimeInUserTimeZone = moment
      .tz(`${date}T${currentTime}`, userTimeZone)
      .format("YYYY-MM-DDTHH:mm:ss");

    return dateTimeInUserTimeZone;
  }

  const handleSubmit = async (event) => {
    const inputSalesOrder = {
      order_id: orderId,
      email_requestor: internalEmail,
      sales_order_date: getDateTimeInUserTimeZone(salesOrderDate),
    };

    try {
      const response = await fetch(
        "https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/order/sales-order",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(inputSalesOrder),
        }
      );

      const data = await response.json();
      const responseBody = JSON.parse(data.body);

      if (!response.ok) {
        throw new Error("Failed to submit sales order");
      }

      const { message } = responseBody;
      if (message == "success") {
        // Store the token in local storage
        localStorage.setItem("token", token);

        setOpenConfirm(false);
        setOpenSuccess(true);
      } else {
        setOpenConfirm(false);
        setOpenFail(true);
      }
    } catch (error) {
      setError("Submission Error: " + error.message);
      console.error("Submission Error:", error.message);
      setOpenConfirm(false);
      setOpenFail(true);
    }
  };

  function inputSuccess() {
    navigate("/order-list");
  }

  useEffect(() => {
    currencySelected(orderDetail.sales_order_currency);
  }, [orderDetail]);

  function currencySelected(currency) {
    if (currency === "IDR") {
      setSelectedCurrency("IDR");
    } else if (currency === "USD") {
      setSelectedCurrency("USD");
    }
  }

  const handleCurrencyChange = (event, currency) => {
    setSelectedCurrency(currency);

    let salesOrderPrice = null;
    if (currency === "IDR") {
      salesOrderPrice = salesOrderPriceIDR;
      orderDetail.sales_order_currency = "IDR";
    } else if (currency === "USD") {
      salesOrderPrice = salesOrderPriceUSD;
      orderDetail.sales_order_currency = "USD";
    }
    
    let totalMRC = 0;
    let totalNRC = 0;
    let totalVat = 0;
    orderDetail.orderItemlistByOrderId.forEach((item) => {
      item.sales_order_nrc_unit_price = 0;
      item.sales_order_nrc_sub_total = 0;
      item.sales_order_nrc_tax = 0;

      item.sales_order_mrc_unit_price = salesOrderPrice;
      item.subtotal_mrc = item.cable_quantity * item.sales_order_mrc_unit_price;
      item.vat_mrc = item.subtotal_mrc * (vat / 100);

      totalMRC += item.month * item.subtotal_mrc;
      totalNRC += item.sales_order_nrc_sub_total;
      totalVat += (item.month * item.vat_mrc) + item.sales_order_nrc_tax;
    });
    setTotalMRC(totalMRC);
    setTotalNRC(totalNRC);
    setTotalVat(totalVat);
  };

  const handleOptionChange = (event) => {
    const { value } = event.target;
    setSelectedOption(value);

    // Update the textarea content based on the selected radio button
    if (value === "GENERAL") {
      setSpecifiedTc(tcText);
    } else if (value === "SPECIFIED") {
      setSpecifiedTc(""); // Clear the textarea for the "specified" option
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const options = { year: "numeric", month: "long", day: "numeric" };
    return date.toLocaleDateString("en-US", options);
  };

  let tcText = `1. Minimum contract for cross connection is 1 year.
2. Early termination will be charged 100% from the remaining contract.
3. Contract term will be renewed automatically.
4. MRC will be charged after handover.
5. Any other terms and conditions which are not stipulated in this SO shall referred to Master Service Agreement ("MSA") between NTTGDCI and NTTI dated on ${formatDate(
    msaDate
  )}.`;

  const handleDownload = async () => {
    try {
      const response = await fetch(downloadUrl, {
        method: "GET", // Use GET to download the file
      });

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName); // Set the desired file name
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link); // Clean up after download
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  return (
    <div className="container-order-input">
      {isLoading && <LoadingScreen />}
      <Dialog open={openConfirm}>
        <DialogTitle>
          {"Are you sure you want to submit this sales order?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Clicking "Yes" will submit this sales order.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            No
          </Button>
          <Button onClick={handleSubmit} color="primary" autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={openSuccess}>
        <DialogTitle>{"Sales Order Form submitted successfully"}</DialogTitle>
        <DialogActions>
          <Button onClick={inputSuccess} color="primary" autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={openFail}>
        <DialogTitle>{"Sales Order Form submitted Failed"}</DialogTitle>
        <DialogActions>
          <Button onClick={handleClose} color="primary" autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openFailConfirm}>
        <DialogTitle>{"Confirm Sales Order Form Failed"}</DialogTitle>
        <DialogActions>
          <Button onClick={handleClose} color="primary" autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openConfirmSucces}>
        <DialogTitle>{"Confirm Sales Order Form successfully"}</DialogTitle>
        <DialogActions>
          <Button onClick={handleClose} color="primary" autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>

      <h1 className="main-title">Cross Connect Sales Order Form</h1>
      <form onSubmit={handleConfirmation}>
        <div className="box-two-part">
          <div className="requestor-information">
            <div className="title-order-input">
              <h5>Sales Order Header</h5>
            </div>
            <div className="textbox">
              <label htmlFor="officeAddress">Customer</label>
              <textarea
                style={{
                  backgroundColor: "lightgrey",
                  color: "black",
                  height: "169px",
                }}
                value="PT. NTT Indonesia 
Wisma 46-Kota BNI, 5th Floor 
Jl. Jenderal Sudirman Kav. 1
Jakarta 10220"
                disabled
              ></textarea>
            </div>
            <div className="textbox-gray">
              <label htmlFor="companyName">Name</label>
              <input
                type="text"
                value={salesOrderDestination}
                onChange={(e) => setSalesOrderDestination(e.target.value)}
                required
                disabled
              />
            </div>
            <div className="textbox">
              <label>Sales Order MSA Date</label>
              <input
                type="date"
                value={msaDate}
                onChange={(e) => setMsaDate(e.target.value)}
                required
              />
            </div>
          </div>

          <div className="destination-information">
            <div className="title-order-input">
              <h5 style={{ visibility: "hidden" }}>.</h5>
            </div>
            <div className="textbox-gray">
              <label htmlFor="salesOrderNo">Sales Order No</label>
              <input
                type="text"
                id="salesOrderNo"
                value={salesOrderNo}
                onChange={(e) => setSalesOrderNo(e.target.value)}
                required
                disabled
              />
            </div>
            <div className="textbox-gray">
              <label htmlFor="orderDate">Date</label>
              <input
                type="date"
                id="salesOrderDate"
                value={salesOrderDate}
                onChange={(e) => setSalesOrderDate(e.target.value)}
                required
                disabled
              />
            </div>
            <div className="textbox-gray">
              <label htmlFor="picName">Prepared By</label>
              <input type="text" value={internalName} disabled />
            </div>
            <div className="radio-button">
              <label>Sales Order Currency</label>
              <div>
                <input
                  type="radio"
                  name="connect"
                  id="connect-one"
                  checked={selectedCurrency === "IDR"}
                  onChange={(event) => handleCurrencyChange(event, "IDR")}
                  enabled
                  required
                />
                <label>IDR</label>
              </div>
              <div>
                <input
                  type="radio"
                  name="connect"
                  id="connect-two"
                  checked={selectedCurrency === "USD"}
                  onChange={(event) => handleCurrencyChange(event, "USD")}
                  enabled
                  required
                />
                <label>USD</label>
              </div>
            </div>
          </div>
        </div>

        {orderDetail.orderItemlistByOrderId &&
          orderDetail.orderItemlistByOrderId.length > 0 &&
          orderDetail.orderItemlistByOrderId.map((order, index) => (
            <div className="box-two-part">
              <div className="requestor-information">
                <div className="title-order-input">
                  <h5>Cross Connect Service ({index + 1})</h5>
                </div>
                <div className="textbox">
                  <label htmlFor="officeAddress">Service Description</label>
                  <textarea
                    style={{
                      backgroundColor: "lightgrey",
                      color: "black",
                      height: "190px",
                    }}
                    disabled
                    value={order.service_description}
                  ></textarea>
                </div>
                <div className="textbox">
                  <label htmlFor="companyName">Month</label>
                  <input
                    type="number"
                    value={order.month}
                    onChange={(e) => handleMonth(index, e.target.value)}
                    required
                  />
                </div>

                <div className="textbox-gray">
                  <label htmlFor="picName">Quantity</label>
                  <input type="number" value={order.cable_quantity} disabled />
                </div>
                <div className="textbox">
                  <label htmlFor="companyName">Unit</label>
                  <input
                    type="text"
                    value={order.unit}
                    onChange={(e) => handleUnit(index, e.target.value)}
                    required
                  />
                </div>
              </div>

              <div className="destination-information">
                <div className="title-order-input">
                  <h5 style={{ visibility: "hidden" }}>.</h5>
                </div>
                <label htmlFor="nrc" style={{ fontSize: "18px" }}>
                  NRC Charging Scheme
                </label>
                <div className="textbox">
                  <label htmlFor="nrc">Unit Price ({selectedCurrency})</label>
                  <input
                    type="number"
                    value={order.sales_order_nrc_unit_price}
                    onChange={(e) => handleUnitPriceNRC(index, e.target.value)}
                    required
                    style={{ textAlign: "right" }}
                  />
                </div>
                <div className="textbox-gray">
                  <label htmlFor="picName">Subtotal ({selectedCurrency})</label>
                  <input
                    type="text"
                    value={new Intl.NumberFormat(locale, {
                      useGrouping: true,
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 9,
                    }).format(order.sales_order_nrc_sub_total)}
                    required
                    disabled
                    style={{ textAlign: "right" }}
                  />
                </div>
                <div className="textbox-gray">
                  <label htmlFor="picName">
                    Vat {vat}% ({selectedCurrency})
                  </label>
                  <input
                    type="text"
                    value={new Intl.NumberFormat(locale, {
                      useGrouping: true,
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 9,
                    }).format(order.sales_order_nrc_tax)}
                    required
                    disabled
                    style={{ textAlign: "right" }}
                  />
                </div>

                <div className="title-order-input"></div>
                <label htmlFor="picName" style={{ fontSize: "18px" }}>
                  MRC Charging Scheme
                </label>
                <div className="textbox">
                  <label htmlFor="picName">
                    Unit Price ({selectedCurrency})
                  </label>
                  <input
                    type="number"
                    value={order.sales_order_mrc_unit_price}
                    onChange={(e) => handleUnitPriceMRC(index, e.target.value)}
                    required
                    style={{ textAlign: "right" }}
                  />
                </div>
                <div className="textbox-gray">
                  <label htmlFor="picName1">
                    Subtotal ({selectedCurrency})
                  </label>
                  <input
                    type="text"
                    value={new Intl.NumberFormat(locale, {
                      useGrouping: true,
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 9,
                    }).format(order.subtotal_mrc)}
                    style={{ textAlign: "right" }}
                  />
                </div>
                <div className="textbox-gray">
                  <label htmlFor="picName2">
                    Vat {vat}% ({selectedCurrency})
                  </label>
                  <input
                    type="text"
                    value={new Intl.NumberFormat(locale, {
                      useGrouping: true,
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 9,
                    }).format(order.vat_mrc)}
                    disabled
                    style={{ textAlign: "right" }}
                  />
                </div>
              </div>
            </div>
          ))}

        <div className="box-two-part">
          <div className="requestor-information">
            <div className="title-order-input">
              <h5>Agreement Details</h5>
            </div>
            <div className="radio-button">
              <label>Terms & Conditions</label>
              <div>
                <input
                  type="radio"
                  name="tc"
                  id="general-tc"
                  value="GENERAL"
                  onChange={handleOptionChange}
                  checked={selectedOption === "GENERAL"}
                  disabled={!msaDate} // Disable if msaDate is empty
                  required
                />
                <label htmlFor="general-tc">
                  Use general terms & conditions
                </label>
              </div>
              <div>
                <input
                  type="radio"
                  name="tc"
                  id="specified-tc"
                  value="SPECIFIED"
                  onChange={handleOptionChange}
                  checked={selectedOption === "SPECIFIED"}
                  disabled={!msaDate} // Disable if msaDate is empty
                />
                <label htmlFor="specified-tc">Specified T&C</label>
              </div>
              <textarea
                placeholder={
                  selectedOption === "SPECIFIED"
                    ? "Enter specified terms & conditions"
                    : ""
                }
                value={specifiedTc}
                onChange={(e) => setSpecifiedTc(e.target.value)}
                style={{
                  width: "100%",
                  marginTop: "8px",
                  padding: "8px",
                  height: "400px",
                }}
                disabled={!msaDate} // Disable if msaDate is empty
                required
              />
              {!msaDate && (
                <p style={{ color: "red", marginTop: "10px" }}>
                  Please enter the MSA Date before selecting the terms &
                  conditions.
                </p>
              )}
            </div>
          </div>

          <div className="destination-information">
            <div className="title-order-input">
              <h5 style={{ visibility: "hidden" }}>.</h5>
            </div>
          </div>
        </div>

        <div className="box-two-part">
          <div className="requestor-information">
            <div className="title-order-input">
              <h5>Total Project Value</h5>
            </div>
            <div className="textbox-gray">
              <label htmlFor="picName">Total NRC ({selectedCurrency})</label>
              <input
                type="text"
                value={new Intl.NumberFormat(locale, {
                  useGrouping: true,
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 9,
                }).format(totalNRC)}
                disabled
                style={{ textAlign: "right" }}
              />
            </div>
            <div className="textbox-gray">
              <label htmlFor="picName">Total MRC ({selectedCurrency})</label>
              <input
                type="text"
                value={new Intl.NumberFormat(locale, {
                  useGrouping: true,
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 9,
                }).format(totalMRC)}
                disabled
                style={{ textAlign: "right" }}
              />
            </div>
            <div className="textbox-gray">
              <label htmlFor="picName">
                Vat {vat}% ({selectedCurrency})
              </label>
              <input
                type="text"
                value={new Intl.NumberFormat(locale, {
                  useGrouping: true,
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 9,
                }).format(totalVat)}
                disabled
                style={{ textAlign: "right" }}
              />
            </div>
            <div className="button-group">
              <button
                className="btn-confirm"
                type="submit"
                name="action"
                value="confirm"
              >
                Confirm
              </button>

              {/* Conditionally render the download button */}
              {isDownloadActive && (
                <button
                  className="btn-download"
                  type="button"
                  onClick={handleDownload}
                >
                  Download
                </button>
              )}
              {isDownloadActive && (
                <button
                  className="btn-submit"
                  type="submit"
                  name="action"
                  value="submit"
                >
                  Submit
                </button>
              )}
            </div>
          </div>

          <div className="destination-information">
            <div className="title-order-input">
              <h5 style={{ visibility: "hidden" }}>.</h5>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default CreateSalesOrder;